import { environment } from 'src/environments/environment'

const baseUrl = environment.ACCOUNT_HOST_URL


export const ACCOUNT_AUTH_URL = `${baseUrl}/api/security/auth/v2/authenticateApp`

// https://apiuat.icreditworks.com/api/security/auth/v2/user/$email
export const ACCOUNT_AUTH_GROUP = {
  POST_USER_LOGIN: `${baseUrl}/api/security/auth/v2/login`,
  // Verify User Role has access
  // GET_VERIFY_USER_ROLE_HAS_ACCESS: `${baseUrl}/api/security/auth/v2/verify/user/access`,
  // POST_USER_LOGIN_NOTIFICATION: `${baseUrl}/api/account/v1/user/post/login`,

  // profile updates block
  POST_VERIFY_USER: `${baseUrl}/api/security/auth/v2/user/$email`,
  POST_RECOVER_PASSWORD: `${baseUrl}/api/security/auth/v2/user/password-reset`,
  POST_RECOVER_EMAIL: `${baseUrl}/api/security/auth/v2/user`,
  // profile updates block end

  AUTH_THIRD_PARTY: `${baseUrl}/api/security/v1/authnThirdParty`,

  // account activation
  ACCOUNT_ACTIVATION: `${baseUrl}/api/network/admin/v1/automated/onboarding/network`,

  SEND_ACTIVATION_NOTIFICATION: `${baseUrl}/api/edelivery/v1/send-direct`
}

const ninthBaseUrl = environment.NINTHWAVE_BASE_URL

// export const NINTH_WAVE_AUTH_GROUP = {
//   // appId, clientId, clientSecret -> token
//   POST_NEW_AUTH_TOKEN: `${ninthBaseUrl}/token/new`,
// }

export const NINTH_WAVE_GROUP = {
  POST_TOKEN_REFRESH: `${ninthBaseUrl}/token/refresh`,
  POST_TOKEN_EXPIRE: `${ninthBaseUrl}/token/expire`,
  GET_SEARCH: `${ninthBaseUrl}/directory/search`,
  // ?id=1059,16880,17153,16847,17137,17391,17149,17542,16875,16885
  // &components=fiID,fiName,fiBrand,capabilities
  GET_RETRIEVE_FI_PROFILE_FROM_IDS: `${ninthBaseUrl}/directory/fiprofile`,
  GET_RETRIEVE_FI_NAME: `${ninthBaseUrl}/directory/finame`,
  POST_FI_SIGN_IN: `${ninthBaseUrl}/accounts`,
  POST_RETRIEVE_ELIG_USECASES: `${ninthBaseUrl}/usecases`,
  POST_OWNERSHIP_VERIFICATION: `${ninthBaseUrl}/authorize`,

}

export const USER_LOGIN_GROUP = {
  POST_USER_LOGIN_NOTIFICATION: `${baseUrl}/api/account/v1/user/post/login`,
  GET_VERIFY_USER_ROLE_HAS_ACCESS: `${baseUrl}/api/security/auth/v2/verify/user/access`,
  GET_LOAN_DETAILS: `${baseUrl}/api/application/v1/user/loan/details`,
  GET_LOAN_SUMMARY: `${baseUrl}/api/application/v1/user/loan/summary`,
  GET_USER_LOAN_LIST_VIEW: `${baseUrl}/api/loanadmin/v1/user/loan/listview`,
  GET_USERGROUP_LOAN_SPLIT_VIEW: `${baseUrl}/api/payment/v1/loan-group/split/details`,
  GET_HOME_VIEW: `${baseUrl}/api/loanadmin/v1/user/loan/homeview`,
  GET_LOAN_ATTRIBUTES: `${baseUrl}/api/application/v1/loan/attributes`,
  POST_VIEW_DOC: `${baseUrl}/api/application/v1/user/loan/docs/view`,
  GET_ARTICLES: `${baseUrl}/api/account/v1/user/content/articles`,
  // used by phase1
  // POST_GET_CREDIT_ARTICLES: `${baseUrl}/api/account/v1/user/content/credit/articles`,
  GET_POPUP_DATA: `${baseUrl}/api/account/v1/user/loan/popups`,
  POST_POPUP_DISABLE: `${baseUrl}/api/account/v1/user/loan/popups/disable`,
  GET_LOAN_PAYMENT_SHEDULE: `${baseUrl}/api/account/v1/user/loan/payment/schedule`,
  GET_PAYOFF_LOAN_PAYMENT_SHEDULE: `${baseUrl}/api/account/v1/user/loan/payment/schedule?isPayOff=true`,
  GET_UNREAD_INBOX_COUNT: `${baseUrl}/api/account/v1/user/notifications/unread/count`,
  GET_ALL_NOTIFICATIONS: `${baseUrl}/api/account/v1/user/notifications/all`,
  GET_NOTIFICATIONS_BY_LOAN_OR_GROUP: `${baseUrl}/api/account/v1/user/notifications`,
  GET_NOTIFICATION_DETAILS: `${baseUrl}/api/application/v1/user/loan/docs/inbox/content?notificationId=$id`,
  POST_UPDATE_NOTIFICATION_STATUS: `${baseUrl}/api/account/v1/user/notifications/preference`,
  POST_ADD_NEW_PAYMENT_METHOD: `${baseUrl}/api/account/v1/user/payment/setup`,
  POST_ADD_PAYMENT_METHOD_MANUALLY: `${baseUrl}/api/account/v1/user/payment`,
  GET_PAYMENT_METHODS: `${baseUrl}/api/payment/v1/loan-group/payment-methods`,
  POST_TOGGLE_AUTOPAY_STATUS: `${baseUrl}/api/payment/v1/autopay/toggle/status`,
  DELETE_PAYMENT_METHOD_NEW: `${baseUrl}/api/payment/v1/user/payment-method`,
  GET_LOAN_GROUP_PAYMENT_ACTIVITY: `${baseUrl}/api/payment/v1/loan-group/payment/activity`,
  GET_PAYMENT_ACTIVITY: `${baseUrl}/api/payment/v1/activity`,
  GET_BANK_NAME : `${baseUrl}/api/system/v1/fi/name`,
  POST_CHANGE_DEFAULT_METHOD: `${baseUrl}/api/payment/v1/user/payment-method/default`,
  GET_REQUEST_DUE_DATE_CHANGE: `${baseUrl}/api/loanadmin/v1/user/loan/due-date`,
  GET_LOAN_SUMMARY_VIEW: `${baseUrl}/api/loanadmin/v1/user/loan/summary/v2`,

  POST_MULTI_PAYMENT_SETUP: `${baseUrl}/api/payment/v1/user/payment/multi/setup`,
  POST_BANKING_SETUP: `${baseUrl}/api/payment/v1/fi`,
 // GET_ALL_BANK_PROFILE_INFO_FOR_SETUP: `${baseUrl}/api/payment/v1/fi`,
  GET_ALL_BANK_INFO_FOR_SETUP: `${baseUrl}/api/payment/v1/fi/list`,
  GET_ALL_BANK_LIST_BY_SEARCH: `${baseUrl}/api/payment/v1/fi/search`,
  GET_ALL_PAYMENT_METHODS_OBSOLETE: `${baseUrl}/api/account/v1/user/payment-methods`,
  GET_ALL_PAYMENT_METHODS_OLD: `${baseUrl}/api/account/v1/user/payments`,
  GET_AUTOPAY_STATUS: `${baseUrl}/api/application/v1/loan/option/autopay`,
  GET_AUTOPAY_REMINDER_STATUS: `${baseUrl}/api/account/v1/user/payment/setup/autopay/reminder`,
  POST_EDIT_PAYMENT_METHOD: `${baseUrl}/api/account/v1/user/editPayment`,
  // POST_CHANGE_AUTOPAY_STATUS: `${baseUrl}/api/account/v1/user/loan/payment/autopay/status`,
  // POST_CHANGE_DEFAULT_METHOD: `${baseUrl}/api/account/v1/user/loan/payment/default-method`,
  DELETE_PAYMENT_METHOD: `${baseUrl}/api/account/v1/user/payment`,
  DELETE_PAYMENT_METHOD_NEW1: `${baseUrl}/api/account/v1/user/loan/payment-method`,
  GET_LAST_PAYMENT_DETAILS: `${baseUrl}/api/account/v1/user/lastPayment`,
  GET_LOAN_ACTIVITY: `${baseUrl}/api/account/v1/user/loan/activity`,
  GET_PI4_LOAN_ACTIVITY: `${baseUrl}/api/account/v1/user/loan/payment/activity`,


  GET_FINMGMNT_LOAN: `${baseUrl}/api/finmgmt/v1/loan/`,
  GET_PI4_DEBIT_CARD_NUMBER: `${baseUrl}/api/payment/v1/account/v1/user/loan/debit-card/activity/details/`,
  GET_LOAN_STATUS: `${baseUrl}/api/account/v1/user/loan/status`,
  GET_LOAN_SUMMARY_DETAILS: `${baseUrl}/api/application/v1/user/loan/summary/details`,
  GET_INCOME_EDUCATION_DETAILS: `${baseUrl}/api/application/v1/user/income-education`,
  GET_USER_CONTACT_DETAILS: `${baseUrl}/api/account/v1/user/profile/contact/address`,
  PUT_UPDATE_USER_CONTACT_DETAILS: `${baseUrl}/api/account/v1/user/profile/contact/address`,
  GET_NOTIFICATION_PREFERENCES: `${baseUrl}/api/account/v1/user/notifications/settings`,
  POST_UPDATE_NOTIFICATION_PREFERENCES: `${baseUrl}/api/account/v1/user/notifications/settings`,
  POST_DELETE_NOTIFICATION: `${baseUrl}/api/account/v1/user/notifications/preference`,
  GET_ALL_FAQS: `${baseUrl}/api/list/v1/faq`,
  POST_FEEDBACK: `${baseUrl}/api/account/v1/user/feedback`,
  GET_ICW_CONTACT_DETAILS: `${baseUrl}/api/list/v1/contact`,
  GET_RELATION_TYPES: `${baseUrl}/api/list/v1/relations`,
  GET_DOCUMENT_CATEGORIES: `${baseUrl}/api/list/v1/document/categories`,
  POST_GET_DOCUMENT_LIST_BY_TYPE: `${baseUrl}/api/list/v1/document-types`,
  GET_ALL_CLOSED_DISPUTES: `${baseUrl}/api/dispute/v1/disputes/closed`,
  // GET_AUTHORIZATION_DOCUMENT: `${baseUrl}/api/application/v1/user/loan/docs/DebitCard/Autopay/authorization?isHtml=true`,
  GET_AUTHORIZATION_DOCUMENT: `${baseUrl}/api/application/v1/user/loan/docs/DebitCard/Autopay/authorization`,
  // 1125
  GET_DISPUTE_DATA_WITH_DISPUTE_ID: `${baseUrl}/api/dispute/v1/dispute/$id`,
  // 1125
  GET_DISPUTE_ATTACHMENTS_WITH_DISPUTE_ID: `${baseUrl}/api/dispute/v1/dispute/attachments/$id`,
  GET_DISPUTE_RELATED_POPUP: `${baseUrl}/api/dispute/v1/case/popup`,
  POST_GET_MY_DENTIST: `${baseUrl}/api/account/v1/user/my/dentist`,
  POST_USER_LOGOUT: `${baseUrl}/api/security/auth/v2/logout`,


  // profile updates block
  POST_RE_AUTH: `${baseUrl}/api/security/auth/v2/reAuth`,

  GET_CURRENT_USER_DETAILS: `${baseUrl}/api/security/v2/currentuser`,
  GET_GLOBAL_VARS: `${baseUrl}/api/system/v1/config/global/var`,

  PUT_UPDATE_PASSWORD: `${baseUrl}/api/security/v2/currentuser/password`,

  // update mobile number
  PATCH_UPDATE_MOBILE_NUMBER: `${baseUrl}/api/security/v2/currentuser/profile`,
  POST_GET_MOBILE_VERIFICATION_OTP: `${baseUrl}/api/security/v1/otp/token`,
  POST_VERIFY_OTP: `${baseUrl}/api/security/v1/phone/verification`,
  // update mobile number end

  // update email
  PATCH_UPDATE_EMAIL: `${baseUrl}/api/security/v2/currentuser/profile`,
  // update email end

  PATCH_UPDATE_PROFILE_PIC: `${baseUrl}/api/security/v2/currentuser/profile`,

  // profile updates block end

  // payments block
  SCAN_DEBIT_CARD: `${baseUrl}/api/application/v1/underwriting/payment/debit-card/scan`,
  GET_LOAN_DATE_DATA: `${baseUrl}/api/account/v1/user/loan/due-date`,
  PUT_CHANGE_DUE_DATE_OBSOLETE: `${baseUrl}/api/account/v1/user/loan/due-date/change`,

  PUT_CHANGE_DUE_DATE: `${baseUrl}/api/loanadmin/v1/user/loan/due-date/change`,
  // POST_ENROLL_IN_AUTOPAY: `${baseUrl}/api/account/v1/user/loan/payment/autopay/status`,
  //OBSOLOTE----
 // POST_MAKE_A_PAYMENT: `${baseUrl}/api/account/v1/user/make-payment`,
 // POST_LOAN_MAKE_A_PAYMENT: `${baseUrl}/api/account/v1/user/loan/make-payment`,
  //OBSOLOTE----
  POST_LOAN_GROUP_MAKE_A_PAYMENT:`${baseUrl}/api/payment/v1/loan-group/payment/submit`
  // payments block end
}
